<button
  shrdUicButton
  variant="headerNav"
  shrdUicFlyout
  [ngbPopover]="popoverContent"
  [placeInStickyParent]="true"
  [showWhiteArrow]="true"
  [class.active]="item.active"
  (visibilityChange)="handleFlyoutVisibilityChange($event)"
  [shrdUtcTrackEvent]="{ category: 'SiteOperations', action: 'MainNavigation', label: item.title + '|L1' }"
>
  <span>{{ item.title }}</span>
</button>

<ng-template #popoverContent>
  <div class="mega-menu-popover container-fluid d-none d-md-block">
    <div class="row">
      <div class="col-24">
        <shrd-uic-flyout-body [autoUpdateFocusScope]="isProductMenu" class="header-mega-menu-item-flyout-body py-0">
          <div class="col-24">
            <shrd-pf-ui-product-menu-links
              *ngIf="isProductMenu; else secondaryMenuLinks"
              [menuItems]="item?.childList"
              [menuTitle]="item.title"
              [inFlyout]="true"
              class="mt-1 mb-2 links-container"
            />
            <ng-template #secondaryMenuLinks>
              <shrd-pf-ui-editorial-menu-links
                [menuItems]="item?.childList"
                [menuTitle]="item.title"
                [inFlyout]="true"
                class="mt-1 mb-2 links-container"
              />
            </ng-template>
          </div>
          <shrd-uic-smartbar *ngIf="isProductMenu" [isFixed]="false" [isLight]="true" containerClasses="ps-3">
            <div class="smartbar-column-left">
              <div class="content-box content-box-tertiary-left">
                <shrd-pf-ui-view-categories-link />
              </div>
            </div>
          </shrd-uic-smartbar>
        </shrd-uic-flyout-body>
      </div>
    </div>
  </div>
</ng-template>
